var bgTimer;
var hasBG = false;
var bg = {
	w: 0,
	h: 0,
	canvas: "",
	ctx: "",
	count: 0,
	max: 100,
	init: function(){
		var count = 0;
		var max = 6;
		setTimeout(function(){
			showBG();
		},Math.random()*(10000 - 5000) + 5000);
		function showBG(){
			$("#bg span").eq(count).addClass("active");
			count++;
			//console.log(count)
			if(count < max){
				setTimeout(function(){
					showBG();
				}, Math.random()*(20000 - 5000) + 5000);
			}
		}
		/*
		bg.canvas 		= document.getElementById("bg_canvas");
		bg.ctx 			= bg.canvas.getContext("2d");
		bg.ctx.lineJoin = 'round';
		bg.dot();
		hasBG = true;
		if(isPage === "about"){
			if(isSmallScreen){
				bg.max = 100;
			}else{
				bg.max = 100;
			}
		}else{
			if(isSmallScreen){
				bg.max = 75;
			}else{
				bg.max = 150;
			}
		}
		
		bg.count = 0;
		clearInterval(bgTimer);
		bgTimer = setInterval(function(){
			var num = Math.floor(Math.random()*(20 - 5) + 5);
			bg.dot(num);
		}, 300);
		*/
	},
	dot: function(num){
		var b = bg.ctx;
		//b.clearRect(0,0,bg.w, bg.h);
		var c = 0;
		var baseX = Math.floor(Math.random()*bg.w);
		var baseY = Math.floor(Math.random()*bg.h);
		var p = Math.PI/180;
		addDot(baseX, baseY);
		//console.log(baseX, baseY);
		var angle = 360/num;
		function addDot(x,y){
			b.beginPath();
			b.fillStyle = "#613b00";

			var r = p*(angle*c);
			
			var cosR = Math.cos(r)*Math.floor(Math.random()*60);
			var sinR = Math.sin(r)*Math.floor(Math.random()*100);
			var _x = cosR + x;
			var _y = sinR + y;
			if(isRetina){
				var s = 1;
				var m = 2;
				var l = 3;
			}else{
				var s = 2;
				var m = 4;
				var l = 6;
			}
			
			if(c%3 === 0){
				b.fillRect(_x, _y, s, s);
				//b.fillRect(cosR, sinR2, 5, 3);
			}else if(c%5 === 0){
				b.fillRect(_x, _y, m, s);
				//b.fillRect(cosR, sinR2, 4, 2);
			}else if(c%7 === 0){
				b.fillRect(_x, _y, m, m);
				//b.fillRect(cosR, sinR2, 2, 4);
			}else if(c%9 === 0){
				b.fillRect(_x, _y, l, m);
				//b.fillRect(cosR, sinR2, 2, 4);
			}else{
				b.fillRect(_x, _y, 1, 1);
				//b.fillRect(cosR, sinR2, 2, 2);
			}
			b.closePath();
			c++;
			if(c < num){
				setTimeout(function(){
					addDot(x,y);
				},33/1000);
			}
		}
		bg.count++;
		if(bg.count >= bg.max){
			clearInterval(bgTimer);
		}
	}
}
function isRetina(){
	return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2)) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
}